import { apiFetch } from "../../lib/api";
import type { Wine, WineInput } from "../../hooks/useWines";
import type { Brand } from "./carte.types";

function withDefaults(wine: any): Wine {
  return {
    ...wine,
    visible: typeof wine.visible === "boolean" ? wine.visible : true,
    highlighted: typeof wine.highlighted === "boolean" ? wine.highlighted : false,
  };
}

export async function updateCarteBrand(brand: Brand): Promise<Brand> {
  const response = await apiFetch(
    "/brand",
    {
      method: "PUT",
      body: JSON.stringify(brand),
    },
    { auth: false }
  );

  if (!response.ok) {
    throw new Error("Erreur lors de la mise a jour de la marque.");
  }

  return response.json();
}

export async function updateCarteAdminEmail(email: string): Promise<string> {
  const response = await apiFetch(
    "/brand/admin-email",
    {
      method: "PUT",
      body: JSON.stringify({ email }),
    },
    { auth: false }
  );

  if (!response.ok) {
    throw new Error("Erreur lors de la mise a jour de l'email admin.");
  }

  const data = await response.json();
  return data.email || "";
}

export async function addCarteWine(input: WineInput): Promise<Wine> {
  const response = await apiFetch("/wines", {
    method: "POST",
    body: JSON.stringify(input),
  });

  if (!response.ok) {
    throw new Error("Erreur lors de l'ajout.");
  }

  return withDefaults(await response.json());
}

export async function updateCarteWine(id: string, partial: Partial<Wine>): Promise<Wine> {
  const response = await apiFetch(`/wines/${id}`, {
    method: "PATCH",
    body: JSON.stringify(partial),
  });

  if (!response.ok) {
    throw new Error("Erreur lors de la mise a jour.");
  }

  return withDefaults(await response.json());
}

export async function deleteCarteWine(id: string): Promise<void> {
  const response = await apiFetch(`/wines/${id}`, { method: "DELETE" });

  if (!response.ok && response.status !== 204) {
    throw new Error("Erreur lors de la suppression.");
  }
}

export async function addCarteWinesBulk(inputs: WineInput[]): Promise<Wine[]> {
  const response = await apiFetch("/wines/bulk", {
    method: "POST",
    body: JSON.stringify(inputs),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: "Erreur" }));
    throw new Error(error.error || "Erreur lors de l'import.");
  }

  const created = await response.json();
  return Array.isArray(created) ? created.map(withDefaults) : [];
}